import React, { useEffect, useState, useRef } from 'react';
import connect from '../../stores/parent-dashboard';
import BackButton from '../../components/back-button';
import {
  weekDaysObj,
  timeTile,
  getTimeList,
  DefaultSelection,
  BehaviourQuestDefaultWeekSelection,
} from '../../constant-data/weekly-schedule';
import { SubmitButton } from '../../components/parent/add-child-form.js';
import { SetWeeklyScheduleApi, ParentHomeApi, TrackWeeklyGoalOnboarding, GetUserTaget } from '../../services/parent-api';
import { SetWeeklyScheduleLoggedoutApi } from '../../services/loggedout-api';
import WeeklyScheduleHeader from '../../components/parent/weekly-schedule-header';
import useClickOutside from '../../components/loggedout/custom-hooks/useClickOutside';
import {
  SelectAllDays,
  DayCheckBox,
} from '../../components/parent/custom-checkbox';
import { assetPath, convertToSeconds, convertToUUIDFormat, getCurrentWeekDates, playPauseAudio, WeeklyGoalDayMap, setItemInLocalStorage, getItemFromLocalStorage, redirectToStudentRoute } from '../../utils/web-helper';
import Image from '../../components/loggedout/common/Image';
import OnboardingWeeklySchedule from '../../components/onboarding/weekly-schedule';
//images
import FormError from '~images/weekly-schedule/form-error.svg';
import SuccessTickImage from '~images/loggedout/icons/success-tick.png';
import i18n from '../../utils/i18n';
import WeeklyGoalSlider from '../../components/weekly-goal-slider';
import WeeklyQuestConfirmationPopup from './weekly-quest-confirmation-popup';
import { queryProfile, updateUserGoal } from '../../services/graphql-req-handler';
import { getABTestValue } from '../../utils/ab-tests';
import PageHead from '../../components/common/page-head/PageHead';
import { isStudentWebsiteEnabled } from '../../../js/utils/feature_mapping';

const WeeklySchedule = ({
  activeStudent,
  weeklySchedule,
  // triggerToaster,
  // initialize,
  loggedout,
  loggedoutStudentData,
  loggedoutOnApiSuccess,
  onboarding,
  successCallback,
  showReminderText,
  setWeeklyGoalData,
  students,
  selectedGrade,
  isOneTapEnabled,
  settings,
  hideBackBtn,
  hideWeeklyScheduleHeader,
  submitCallbackHandler,
  childId
}) => {
  const dropdownRef = useRef(null);

  const [showError, setError] = useState({
    weekDaysSelectError: false,
    notificationsError: false,
  });
  const [selectedTimeTile, setSelectedTimeTile] = useState(() => timeTile[0]);
  const [selectAmPm, setActiveAmPm] = useState(selectedTimeTile.isAmPm);
  const [timeList, setTimeList] = useState(() => getTimeList(selectAmPm));
  const [showDropDown, setDropDownVisible] = useState(false);
  const [emailReminder, setEmailReminder] = useState(true);
  const [selectAllCheck, setSelectAllCheck] = useState(false);
  const [weekDays, setWeekDays] = useState(() => weekDaysObj(selectAllCheck));
  const [apiSuccessTick, setApiSuccessTick] = useState(false);
  const [mobileReminder, setMobileReminder] = useState(false);
  const [userTargetId, setUserTargetId] = useState('');
  const [mailStudent, setMailStudent] = useState(null);
  const [weeklyGoalProgress, setWeeklyGoalProgress] = useState(45);
  const [weeklyQuestPopupShown, setWeeklyQuestPopupShown] = useState(false);
  const [userProfileGoalInfo, setUserProfileGoalInfo] = useState(null);

  const behaviourQuestEnabled= getABTestValue("Parent", "BQ") === "bq_on" ? true : false

  useEffect(() => {
    setActiveAmPm(selectedTimeTile.isAmPm);
    console.log(selectedTimeTile);
  }, [selectedTimeTile, setSelectedTimeTile]);

  useEffect(() => {
    setTimeList(() => getTimeList(selectAmPm));
    setSelectedTimeTile((prevState) => ({ ...prevState, isAmPm: selectAmPm }));
  }, [selectAmPm]);

  useEffect(() => {
    initializeDefault();
    if ( !loggedout || (!weeklySchedule && (activeStudent && activeStudent.id || childId)) ) {
      trackAnalyticsEvent(behaviourQuestEnabled ? 'Weekly Goal Page Opened': 'Weekly Schedule Opened',
      { from: onboarding ? 'Onboarding' :'Settings' });
      let student = null;
      if (window.location.search.includes('set_goal=1')) {
        const queryParamsArr = window.location.search.split('&');
        const studentIdStr = queryParamsArr.filter(el => el.includes('student_id='))[0];
        const studentId = studentIdStr && studentIdStr.split('=')[1];
        student = students.filter(el => el.id === studentId)[0];
        if (student) {
          setMailStudent(student);
        }
      }
      const getUserTarget = async (studentId = null) => {
        try {
          let userTarget = await GetUserTaget({ student_id: studentId ? studentId : activeStudent && activeStudent.id || childId});
          if (userTarget && userTarget.student_target) {
            setUserTargetId(userTarget.student_target.id);
            setWeeklyGoalData(userTarget.student_target);
          }
        } catch (e) {
          console.log(e);
        }
      };
      getUserTarget(student && student.id);
      if(!loggedout && !onboarding && behaviourQuestEnabled) {
        fetchUserProfile();
      }
    }
  }, []);

  useEffect(() => {
    if (emailReminder || mobileReminder) {
      setError((errorState) => ({ ...errorState, notificationsError: false }));
    }
  }, [emailReminder, mobileReminder]);

  useEffect(() => {
    if (loggedout) {
      trackAnalyticsEvent(behaviourQuestEnabled ? 'Weekly Goal Page Opened':'Weekly Schedule Opened', {
        from: 'Logged-out Page',
      });
    } else {
      let weekObj = null;
      if (!onboarding && weeklySchedule && weeklySchedule.reminder_time) {
        weekObj = weekDaysObj(false);
        weekObj.forEach((val, index, arr) => {
          return (arr[
            index
          ].isChecked = weeklySchedule.practice_day_names.includes(val.day));
        });
        setWeekDays(() => weekObj);
        setSelectAllCheck(weeklySchedule.practice_day_names.length === 7);
        setEmailReminder(weeklySchedule.send_reminder);
        setSelectedTimeTile(() =>
          getTimeIn12Format(weeklySchedule.reminder_time)
        );
        // setActiveAmPm(getTimeIn12Format().isAmPm)
      }
      setMinutes(weekObj);
    }
  }, [weeklySchedule]);

  const initializeDefault = () => {
    weekDays.map(day => day.isChecked = DefaultSelection.days.includes(day.id));
    if(behaviourQuestEnabled) {
      setSelectedTimeTile(timeTile.filter(time => time.id === BehaviourQuestDefaultWeekSelection.time)[0]);
      setWeeklyGoalProgress(20);
    } else {
      setSelectedTimeTile(timeTile.filter(time => time.id === DefaultSelection.time)[0]);
    }
    setWeekDays(weekDays);
    playPauseAudio(true, true);
  }

  const setMinutes = (weekDays = null) => {
    const minutes = (weeklySchedule) ? weeklySchedule.target_value: null;
    if(minutes) {
      let time = minutes/60;
      if(behaviourQuestEnabled) {
        if(onboarding || !weekDays) {
          setWeeklyGoalProgress(time/BehaviourQuestDefaultWeekSelection.days.length);
        } else {
          let selectedWeekDays = [];
          weekDays.forEach((val) => {
            val.isChecked === true && selectedWeekDays.push(val.day);
          });
          console.log('BQ Enabled', time, selectedWeekDays);
          setWeeklyGoalProgress(time/selectedWeekDays.length);
        }
      } else {
        setWeeklyGoalProgress(time);
      }
    }
  }

  const getTimeIn12Format = (time = '11:00') => {
    let [hour, minute] = time.split(':'); //just to get hours and minutes only.
    let suffix = Number(hour) >= 12 ? 'PM' : 'AM';
    let hoursIn12Format = ((Number(hour) + 11) % 12) + 1;
    return {
      time: hoursIn12Format + ':' + (minute || '00'),
      isAmPm: suffix,
      hour: parseInt(hoursIn12Format),
      minute: parseInt(minute),
    };
  };

  const backHandler = () => {
    trackAnalyticsEvent(behaviourQuestEnabled ? 'Interacted Weekly Goal Page': 'Interacted Weekly Schedule', {
      'Tapped On': 'Back',
      'From': (onboarding) ? 'Onboarding' : 'Settings'
    });
    if (window.location.search.includes('set_goal=1')) {
      return window.location = '/';
    }
    window.history.back();
  };

  const Header = () => {
    return (
      <div className="page-heading weekly-goal-page-head">
        <p>Set {mailStudent ? mailStudent.name : activeStudent.name}’s Weekly Schedule</p>
      </div>
    );
  };

  const dayHandler = (e) => {
    let targetElm = e.target.value;
    let checked = e.target.checked;
    let weekDay = weekDays.map((val) => {
      if (val.day === targetElm) {
        return { ...val, isChecked: checked };
      } else {
        return val;
      }
    });
    weekDay.filter((val) => val.isChecked === false).length == 0
      ? setSelectAllCheck(true)
      : setSelectAllCheck(false);
    setWeekDays(weekDay);
    setError((errorState) => ({ ...errorState, weekDaysSelectError: false }));
    if(!loggedout) {
      const analyticsObj = {
        'Tapped On': 'Day',
        'From': (onboarding) ? 'Onboarding' : 'Settings'
      }

      if(behaviourQuestEnabled) {
        analyticsObj['Clicked On'] = 'Day Goal'
      };

      trackAnalyticsEvent(behaviourQuestEnabled ? 'Interacted Weekly Goal Page':'Interacted Weekly Schedule', analyticsObj);
    }
  };

  const timeListHandler = (val) => {
    setDropDownVisible((prevState) => !prevState);
    setSelectedTimeTile(val);
  };
  const dropDownHandler = () => {
    if(!loggedout) {
      const analyticsObj = {
        'Tapped On': 'Time Dropdown',
        'From': (onboarding) ? 'Onboarding' : 'Settings'
      }

      if(behaviourQuestEnabled) {
        analyticsObj['Clicked On'] = ' Reminder Time'
      };

      trackAnalyticsEvent(behaviourQuestEnabled ? 'Interacted Weekly Goal Page':'Interacted Weekly Schedule', analyticsObj);
    }
    setDropDownVisible((prevState) => !prevState);
  };

  const getSelectedDays = () => {
    let selectedWeekDays = [];
    weekDays.forEach((val) => {
      val.isChecked === true && selectedWeekDays.push(val.day);
    });
    return selectedWeekDays;
  }

  const validation = () => {
    let selectedWeeekDays = getSelectedDays();
    if (selectedWeeekDays.length) {
      return selectedWeeekDays;
    }
    setError((errorState) => ({ ...errorState, weekDaysSelectError: true }));
    return false;
  };
  // to convert time according to AM/PM
  const getFormattedTime = () => {
    let formattedTime = '';
    if (selectAmPm == 'PM') {
      formattedTime = `${
        selectedTimeTile.hour == 12 ? 12 : 12 + selectedTimeTile.hour
      }:${selectedTimeTile.minute == 0 ? '00' : selectedTimeTile.minute}`;
    } else {
      formattedTime = `${
        selectedTimeTile.hour == 12 ? '00' : selectedTimeTile.hour
      }:${selectedTimeTile.minute == 0 ? '00' : selectedTimeTile.minute}`;
    }
    return formattedTime;
  };
  // send api request and save the weekly schedule
  const submitHandler = async (clickedSkip = false) => {
    localStorage.removeItem("userCurrentScreen");
    if(clickedSkip) {
      trackAnalyticsEvent('Weekly Goal Skipped', {
        'from' : 'Onboarding'
      });
      trackAnalyticsEvent(behaviourQuestEnabled ? 'Interacted Weekly Goal Page':'Interacted Weekly Schedule', {
        'Tapped On': 'Set Later',
        'From': (onboarding) ? 'Onboarding' : 'Settings'
      });
      return setOnboardingDone();
    }
    if (!validation()) {
      return;
    }
    if(behaviourQuestEnabled && !weeklyQuestPopupShown && checkCurrentWeekQuestAchieved()) {
      setWeeklyQuestPopupShown(true);
    } else {

      let targetId = weeklySchedule && weeklySchedule.id || userTargetId || childId
      let selectedDaysReq = getSelectedDays();
      let body = {
        user_target: {
          target_value_in_minutes: behaviourQuestEnabled ? (weeklyGoalProgress * validation().length) :weeklyGoalProgress,
          practice_days: validation(),
          reminder_time: getFormattedTime(),
          send_reminder: emailReminder,
        },
        id: targetId
      };
      try {
        if(behaviourQuestEnabled) {
          const reqObj = {
            "userProfileInput": {
              "userId": convertToUUIDFormat(activeStudent?.id || childId),
              "weeklyGoalInput": {
                "days": generateDays(),
                "duration": convertToSeconds(weeklyGoalProgress)
              }
            }
          }
          updateUserGoal(reqObj).then((resp) => {
            console.log(resp);
          })
          .catch((error) => {
            console.log('error in updating weekly goal graphql call', error);
          });
        }
        let res = await SetWeeklyScheduleApi(body, targetId);
        if (res.error) {
          return;
        }

        const analyticsObj = {
          'From': onboarding ? 'Onboarding' : 'Settings',
          'Practice Time': getFormattedTime(),
          'Email Notifications': emailReminder ? 'On' : 'Off'
        };

        if(behaviourQuestEnabled) {
          analyticsObj['Time Goal'] = (weeklyGoalProgress + ' mins');
          analyticsObj['Days Goal'] = (validation().length + ' days');
          analyticsObj['Calendar Days'] = validation();
        }

        trackAnalyticsEvent(behaviourQuestEnabled ? 'Weekly Goal Set':'Weekly Schedule Set', analyticsObj);

        trackAnalyticsEvent(behaviourQuestEnabled ? 'Interacted Weekly Goal Page':'Interacted Weekly Schedule', {
          'Tapped On': 'Set Schedule',
          'From': (onboarding) ? 'Onboarding' : 'Settings',
          'Goal Value': (weeklyGoalProgress + ' mins'),
          'Days Set': selectedDaysReq,
          'Time Set': getFormattedTime(),
          'Count Days': selectedDaysReq.length,
        });

        if(onboarding) {
          return setOnboardingDone();
        }

        window.localStorage.setItem('toasterTrigger', true);
        if(submitCallbackHandler) {
          return submitCallbackHandler();
        }
        if(isStudentWebsiteEnabled()){
          redirectToStudentRoute('/', true);
          return;
        }else{
          return (location.href = '/');
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const generateDays = () => {
    let days = validation();
    let result = days.map((x) => {
      return WeeklyGoalDayMap[x];
    });
    return result;
  }

  const checkCurrentWeekQuestAchieved = () => {
    if(userProfileGoalInfo && userProfileGoalInfo.rewardsHistory && userProfileGoalInfo.rewardsHistory.previousWeeklyQuestBadgeAchievedDateTimeUTC) {
      const currentWeekDates = getCurrentWeekDates();
      const index = currentWeekDates.findIndex((x) => x === userProfileGoalInfo.rewardsHistory.previousWeeklyQuestBadgeAchievedDateTimeUTC);
      if(index !== -1) {
        return true;
      }
    }
    return false;
  }

  const fetchUserProfile = async () => {
    try {
      let resp = await queryProfile({
        "userId": convertToUUIDFormat(activeStudent?.id || childId)
      });
      if(resp && resp.userProfile) {
        setUserProfileGoalInfo(resp.userProfile);
      }
    }
    catch(e) {
      console.log(e);
    }
  }

  const setOnboardingDone = async () => {
    const fromLandingPageOnboarding =  getItemFromLocalStorage('viaOnboarding') &&  getItemFromLocalStorage('from_landing_page');
    try {
      !fromLandingPageOnboarding && setItemInLocalStorage('redirect_to_purchase', true);
      await TrackWeeklyGoalOnboarding();
      successCallback && successCallback('weekly_goal_shown');
    }
    catch(e) {
      console.log('Error in API', e);
    }
  }
  const dropDownHandlerForOutside = (e) => {
    return;
  };

  const weekDaysHandlerOnSelectAll = (selectDeselect) => {
    let weekDay = weekDays.map((val) => {
      return { ...val, isChecked: selectDeselect };
    });
    setWeekDays(weekDay);
    setError((errorState) => ({ ...errorState, weekDaysSelectError: false }));
  };

  const handleSelectAllDays = (e) => {
    if(!loggedout) {
      const analyticsObj = {
        'Tapped On': 'Day',
        'From': (onboarding) ? 'Onboarding' : 'Settings'
      }

      if(behaviourQuestEnabled) {
        analyticsObj['Clicked On'] = 'Day Goal'
      };

      trackAnalyticsEvent(behaviourQuestEnabled ? 'Interacted Weekly Goal Page':'Interacted Weekly Schedule', analyticsObj);
    }
    weekDaysHandlerOnSelectAll(e.target.checked);
    setSelectAllCheck((prevState) => !prevState);
  };

  const handleSubmitForLoggedout = async () => {
    const reminderNotSelected = !emailReminder && !mobileReminder;
    // resetting the error states
    setError({
      weekDaysSelectError: false,
      notificationsError: false,
    });
    if (!validation() || reminderNotSelected) {
      if (reminderNotSelected) {
        setError((errorState) => ({ ...errorState, notificationsError: true }));
      }
      return;
    }
    let params = {
      user_target: {
        student_id: loggedoutStudentData.studentId,
        target_value_in_minutes: behaviourQuestEnabled ? (weeklyGoalProgress * validation().length) :weeklyGoalProgress,
        practice_days: validation(),
        reminder_time: getFormattedTime(),
        send_reminder: emailReminder,
        send_app_reminder: mobileReminder,
      },
    };
    try {
      await SetWeeklyScheduleLoggedoutApi(params);
      setApiSuccessTick(true);

      const analyticsObj = {
        From: 'Logged-out Page',
        'Practice Time': getFormattedTime(),
        'Email Notifications': emailReminder ? 'On' : 'Off',
        'Mobile Notifications': mobileReminder ? 'On' : 'Off',
      }

      if(behaviourQuestEnabled) {
        analyticsObj['Time Goal'] = (weeklyGoalProgress + ' mins');
        analyticsObj['Days Goal'] = (validation().length + ' days');
        analyticsObj['Calendar Days'] = validation();
      }

      trackAnalyticsEvent(behaviourQuestEnabled ? 'Weekly Goal Set':'Weekly Schedule Set', analyticsObj);
      // check useEffect after this
    } catch (e) {
      console.log('api failed');
      // if api fails redirect to home page
      window.location.href = '/signin';
    }
  };

  const saveChanges = () => {
    submitHandler();
  }

  const continueEditing = () => {
    setWeeklyQuestPopupShown(false);
  }

  useEffect(() => {
    if (apiSuccessTick) {
      setTimeout(() => {
        // this navigates to the success page after showing tick for 500ms
        loggedoutOnApiSuccess({ emailReminder, mobileReminder });
      }, 1000);
    }
  }, [apiSuccessTick]);

  useClickOutside(dropdownRef, () => setDropDownVisible(() => false));
  if (loggedout) {
    return (
      <div className="weekly-schedule-wrapper">
        <h2 className="step-points">
          {
            behaviourQuestEnabled ?
            <>
              1. Set daily schedule - {weeklyGoalProgress} minutes a day
            </>
            :
            <>
              1. Set <span>weekly goal</span> - {weeklyGoalProgress} minutes a week
            </>
          }
        </h2>
        <WeeklyGoalSlider progress={weeklyGoalProgress} onChange={setWeeklyGoalProgress} behaviourQuestEnabled={behaviourQuestEnabled}/>
        <h2 className="step-points">
          {
            behaviourQuestEnabled ?
            <>
              2. Select weekly schedule - {getSelectedDays().length > 1 ? `${getSelectedDays().length} days`: `${getSelectedDays().length} day`} a week
            </>
            :
            <>
              2. Select {i18n.t('practice')} <span>days</span>
            </>
          }
        </h2>
        <div className="days-container">
          <SelectAllDays
            isChecked={selectAllCheck}
            onChange={handleSelectAllDays}
          />
          <DayCheckBox data={weekDays} checkBoxHandler={dayHandler} />
          {showError.weekDaysSelectError ? (
            <p className="error-state">
              <Image src={FormError} alt="error" />
              This field is required
            </p>
          ) : null}
        </div>
        <h2 className="step-points practice-heading">
          3. Select {i18n.t('practice')} <span>time</span>
        </h2>
        <div className="time-container">
          <ul className="time-tile-section">
            {timeTile.map((val) => {
              let activeTimeTile =
                val.time === selectedTimeTile.time &&
                val.isAmPm === selectedTimeTile.isAmPm
                  ? 'active-time-tile'
                  : '';
              return (
                <li
                  key={val.id}
                  className={activeTimeTile}
                  onClick={() => {
                    if(behaviourQuestEnabled) {
                      trackAnalyticsEvent('Interacted Weekly Goal Page', {'Clicked On': 'Reminder Time'});
                    }
                    setSelectedTimeTile(val)
                  }}
                >{`${val.time} ${val.isAmPm}`}</li>
              );
            })}
          </ul>
          <h2 className="or-seperator">OR</h2>
          <div className="time-dropdown-section">
            <h2>Set your time</h2>
            <div ref={dropdownRef} className="time-dropdown-container">
              <div
                className="time-dropdown--loggedout"
                style={
                  showDropDown
                    ? {
                        boxShadow: '0 1px 16px 0 rgba(0, 0, 0, 0.06)',
                        zIndex: 3,
                      }
                    : {}
                }
              >
                <div
                  className="selected-time"
                  onClick={(e) => dropDownHandler(e)}
                  style={showDropDown ? { border: 'none' } : {}}
                >
                  {selectedTimeTile.time}
                </div>
                {showDropDown && (
                  <ul>
                    {timeList.map((val) => (
                      <li
                        onClick={() => timeListHandler(val)}
                      >{`${val.time} ${val.isAmPm}`}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div className="am-pm-wrapper">
              <span
                className={
                  'am-pm-cta ' + (selectAmPm == 'AM' ? 'active-ampm' : '')
                }
                onClick={() => setActiveAmPm('AM')}
              >
                AM
              </span>
              <span
                className={
                  'am-pm-cta ' + (selectAmPm == 'PM' ? 'active-ampm' : '')
                }
                onClick={() => setActiveAmPm('PM')}
              >
                PM
              </span>
            </div>
          </div>
        </div>
        <div className="email-notification-section">
          <h2 className="step-points">
            4. Receive <span>notifications</span> on
          </h2>
          <p>Email</p>
          <div className="email-toggle-wrap">
            <input
              type="checkbox"
              id="emailNotification"
              checked={emailReminder}
              onChange={() => setEmailReminder((prevState) => !prevState)}
            />
            <label for="emailNotification"></label>
          </div>
          <p style={{ marginLeft: 20 }}>Mobile</p>
          <div className="email-toggle-wrap">
            <input
              type="checkbox"
              id="mobileNotification"
              checked={mobileReminder}
              onChange={() => setMobileReminder((prevState) => !prevState)}
            />
            <label for="mobileNotification"></label>
          </div>
        </div>
        {showError.notificationsError ? (
          <p className="error-state">
            <Image src={FormError} alt="error" />
            Please turn on notifications where you would like to receive
            reminders
          </p>
        ) : null}
        <div className="weekly-goal__maincta">
          {apiSuccessTick ? (
            <Image src={SuccessTickImage} alt="tick" />
          ) : (
            <button onClick={handleSubmitForLoggedout}>Set Schedule</button>
          )}
        </div>
      </div>
    );
  }
  else if (onboarding) {
    return (<OnboardingWeeklySchedule
      selectAllCheck={selectAllCheck}
      handleSelectAllDays={handleSelectAllDays}
      weekDays={weekDays}
      dayHandler={dayHandler}
      FormError={FormError}
      selectedTimeTile={selectedTimeTile}
      showError={showError}
      showDropDown={showDropDown}
      selectAmPm={selectAmPm}
      timeList={timeList}
      setActiveAmPm={setActiveAmPm}
      setSelectedTimeTile={setSelectedTimeTile}
      submitHandler={submitHandler}
      timeTile={timeTile}
      timeListHandler={timeListHandler}
      dropDownHandler={dropDownHandler}
      dropdownRef={dropdownRef}
      showReminderText={showReminderText}
      selectedGrade={selectedGrade}
      weeklyGoalProgress={weeklyGoalProgress}
      setWeeklyGoalProgress={setWeeklyGoalProgress}
      isOneTapEnabled = {isOneTapEnabled}
      behaviourQuestEnabled={behaviourQuestEnabled}
      getSelectedDays={getSelectedDays}
    />)
  }
  return (
    <>
      <div className="parent-onboarding add-child-details">
        {!hideBackBtn && <BackButton backHandler={backHandler} />}
        <div className={`container ${hideWeeklyScheduleHeader ? 'no-margin-top' : ""}`} onClick={dropDownHandlerForOutside}>
        {!hideWeeklyScheduleHeader && <>
          <PageHead>
            <Header />
          </PageHead>
           <WeeklyScheduleHeader activeStudent={activeStudent} />
           </>}
          <div className="weekly-schedule-wrapper">
            <h2 className="step-points">
              {
                behaviourQuestEnabled ?
                <>
                  1. Set daily schedule - {weeklyGoalProgress} minutes a day
                </>
                :
                <>
                  1. Set <i>weekly goal</i> - {weeklyGoalProgress} minutes a week
                </>
              }
            </h2>
            <WeeklyGoalSlider progress={weeklyGoalProgress} onChange={setWeeklyGoalProgress} behaviourQuestEnabled={behaviourQuestEnabled} />
            <h2>
              {
                behaviourQuestEnabled ?
                <>
                  2. Select weekly schedule - {getSelectedDays().length > 1 ? `${getSelectedDays().length} days`: `${getSelectedDays().length} day`} a week
                </>
                :
                <>
                  2. Select {i18n.t('Practice')} Days
                </>
              }
            </h2>
            <div className="days-container">
              <SelectAllDays
                isChecked={selectAllCheck}
                onChange={handleSelectAllDays}
              />
              <DayCheckBox data={weekDays} checkBoxHandler={dayHandler} />
              {showError.weekDaysSelectError ? (
                <p className="error-state">
                  <img src={assetPath(FormError)} />
                  This field is required
                </p>
              ) : null}
            </div>
            <h2>3. Select {i18n.t('Practice')} Time</h2>
            <div className="time-container">
              <ul className="time-tile-section">
                {timeTile.map((val) => {
                  let activeTimeTile =
                    val.time === selectedTimeTile.time &&
                    val.isAmPm === selectedTimeTile.isAmPm
                      ? 'active-time-tile'
                      : '';
                  return (
                    <li
                      key={val.id}
                      className={activeTimeTile}
                      onClick={() => {
                        if(behaviourQuestEnabled) {
                          trackAnalyticsEvent('Interacted Weekly Goal Page', {'Clicked On': 'Reminder Time'});
                        };
                        setSelectedTimeTile(val);
                      }}
                    >{`${val.time} ${val.isAmPm}`}</li>
                  );
                })}
              </ul>
              <h2 className="or-seperator">OR</h2>
              <div className="time-dropdown-section">
                <h2>Set your own time</h2>
                <div ref={dropdownRef} className="time-dropdown-container">
                  <div
                    className="selected-time"
                    onClick={(e) => dropDownHandler(e)}
                  >
                    {selectedTimeTile.time}
                  </div>
                  {showDropDown && (
                    <ul>
                      {timeList.map((val) => (
                        <li
                          onClick={() => timeListHandler(val)}
                        >{`${val.time} ${val.isAmPm}`}</li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="am-pm-wrapper">
                  <span
                    className={
                      'am-pm-cta ' + (selectAmPm == 'AM' ? 'active-ampm' : '')
                    }
                    onClick={() => setActiveAmPm('AM')}
                  >
                    AM
                  </span>
                  <span
                    className={
                      'am-pm-cta ' + (selectAmPm == 'PM' ? 'active-ampm' : '')
                    }
                    onClick={() => setActiveAmPm('PM')}
                  >
                    PM
                  </span>
                </div>
              </div>
            </div>
            <div className="email-notification-section">
              <h2>4. Receive notifications on</h2>
              <p>Email</p>
              <div className="email-toggle-wrap">
                <input
                  type="checkbox"
                  id="emailNotification"
                  checked={emailReminder}
                  onChange={() => setEmailReminder((prevState) => !prevState)}
                />
                <label for="emailNotification"></label>
              </div>
            </div>
          </div>
          <SubmitButton submitHandler={()=>submitHandler()}  cancelHandler={true}/>
        </div>
      </div>
      { weeklyQuestPopupShown &&
        <WeeklyQuestConfirmationPopup saveChanges={saveChanges} continueEditing={continueEditing} />
      }
    </>
  );
};

function mapStateToProps(state) {
  return {
    settings: state.settings,
    weeklySchedule: state.weeklySchedule,
    activeStudent: state.student,
    students: state.students,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    triggerToaster: () => dispatch({ type: 'TRIGGER_TOASTER', payload: true }),
    initialize: (data) => dispatch({ type: 'INITIALIZE', payload: data }),
    setWeeklyGoalData: (data) =>
      dispatch({ type: 'SET_WEEKLY_GOAL_DATA', payload: data }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, WeeklySchedule);
